import { Action, Reducer } from 'redux'
import { ICarrierAccounting, ICarrierAccountingState } from 'types/carrier'
import {
  CARRIER_ACCOUNTING_MODAL,
  CARRIER_EDIT_ACCOUNTING_ACTION_TYPES,
  CARRIER_ACCOUNTING_ACTION_TYPES,
} from 'apps/carrier/utils/actions/carrierAccounting'

const defaultState = {
  fetching: false,
  accounting: undefined,
  error: undefined,
  showModal: false,
  updating: false,
} as ICarrierAccountingState

const {
  CARRIER_ACCOUNTING_FAILURE,
  CARRIER_ACCOUNTING_REQUEST,
  CARRIER_ACCOUNTING_SUCCESS,
} = CARRIER_ACCOUNTING_ACTION_TYPES
const { CARRIER_ACCOUNTING_MODAL_CLOSE, CARRIER_ACCOUNTING_MODAL_OPEN } = CARRIER_ACCOUNTING_MODAL
const {
  CARRIER_EDIT_ACCOUNTING_FAILURE,
  CARRIER_EDIT_ACCOUNTING_REQUEST,
  CARRIER_EDIT_ACCOUNTING_SUCCESS,
} = CARRIER_EDIT_ACCOUNTING_ACTION_TYPES

interface IErrorAction extends Action<string> {
  error: string
}

interface ISuccessAction extends Action<string> {
  payload: ICarrierAccounting
}

type CarrierAccountingAction = Action<string> | IErrorAction | ISuccessAction

const carrierAccountingReducer: Reducer<ICarrierAccountingState, CarrierAccountingAction> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case CARRIER_ACCOUNTING_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: undefined,
      }
    }
    case CARRIER_ACCOUNTING_SUCCESS: {
      return {
        ...state,
        fetching: false,
        accounting: (action as ISuccessAction).payload,
      }
    }
    case CARRIER_ACCOUNTING_FAILURE: {
      return {
        ...state,
        fetching: false,
        error: (action as IErrorAction).error,
      }
    }
    case CARRIER_ACCOUNTING_MODAL_OPEN: {
      return {
        ...state,
        error: undefined,
        showModal: true,
      }
    }
    case CARRIER_ACCOUNTING_MODAL_CLOSE: {
      return {
        ...state,
        showModal: false,
      }
    }
    case CARRIER_EDIT_ACCOUNTING_REQUEST: {
      return {
        ...state,
        updating: true,
      }
    }
    case CARRIER_EDIT_ACCOUNTING_SUCCESS: {
      return {
        ...state,
        updating: false,
        showModal: false,
        accounting: (action as ISuccessAction).payload,
      }
    }
    case CARRIER_EDIT_ACCOUNTING_FAILURE: {
      return {
        ...state,
        updating: false,
        error: (action as IErrorAction).error,
      }
    }
    default:
      return state
  }
}

export default carrierAccountingReducer
